import {
    SUBMIT_LOGIN_INFO
} from './actionTypes';

export function loginSubmit(userInfo) {
    return {
        type: SUBMIT_LOGIN_INFO,
        userInfo
    }
}